import { z } from "zod";
import { PermitClassificationSchema } from "./classification";
import { PermitStatusSchema } from "./status";
import { PermitRootTypeSchema, PermitSubTypeSchema } from "./application_type";

export const PermitStatusFilterSchema = z
  .object({
    enabledStatuses: z.array(PermitStatusSchema),
  })
  .strict();

export const PermitFiltersSchema = z.object({
  enabledClassifications: z.array(PermitClassificationSchema),
  enabledStatuses: z.array(PermitStatusSchema),
  enabledTypes: z
    .array(
      z.object({
        type: PermitRootTypeSchema,
        subTypes: z.array(PermitSubTypeSchema),
      })
    )
    .optional(),

  maxAge: z.number().optional(),
  projectSize: z.tuple([z.number().nullable(), z.number().nullable()]),
  freeTextSearch: z.string(),
});

export type PermitStatusFilter = z.infer<typeof PermitStatusFilterSchema>;

export type PermitFilters = z.infer<typeof PermitFiltersSchema>;
